import _ from 'lodash';
import React from 'react';



export function useSteps<TStep>({
  steps, onReachedStart, onReachedEnd
}: {
  steps: readonly TStep[];
  onReachedStart?: () => void;
  onReachedEnd?: () => void;
}) {
  const [step, setStep] = React.useState<TStep>(steps[0]);



  const goToPrev = React.useCallback(
    (overrideStep?: TStep) => {
      setStep(prev => {
        const index = _.findIndex(steps, s => s === prev);
        if (index === 0) {
          onReachedStart?.();
          return prev;
        }

        const newStep = steps[index - 1];
        return overrideStep ?? newStep;
      });
    },
    [
      onReachedStart,
      steps
    ]
  );



  const goToNext = React.useCallback(
    (overrideStep?: TStep) => {
      setStep(prev => {
        const index = _.findIndex(steps, s => s === prev);
        if (index === steps.length) {
          onReachedEnd?.();
          return prev;
        }

        const newStep = steps[index + 1];
        return overrideStep ?? newStep;
      });
    },
    [
      onReachedEnd,
      steps
    ]
  );



  const previousButtonText = React.useMemo(
    () => step === _.first(steps) ? "Cancel" : "Previous",
    [step, steps]
  );

  const submitButtonText = React.useMemo(
    () => step === _.last(steps) ? "Submit" : "Next",
    [step, steps]
  );



  return React.useMemo(
    () => ({
      step,
      previousButtonText,
      submitButtonText,
      goToPrev,
      goToNext
    }),
    [
      step,
      previousButtonText,
      submitButtonText,
      goToNext,
      goToPrev
    ]
  );
}
